module.exports = __webpack_public_path__ + "img/PK.7b788930.svg";